import type { CommunityDetail } from '@pba/react-network';
import { useState } from 'react';
import { usePermissions } from 'permissions';
import { Button, Card, Icon, type ModalOptions, Space } from 'ui';
import { CommunityAdmins } from './community-admins';
import { CommunityMembers } from './community-members';
import { InviteFriendsModal, type InviteFriendsModalOptions } from './invite-friends-modal';

type P = {
  community: CommunityDetail;
};

const CommunityMembersCard = ({ community }: P) => {
  const [inviteFriendsOptions, setInviteFriendsOptions] = useState<ModalOptions<InviteFriendsModalOptions>>({
    isOpened: false,
  });
  const { canInviteToCommunity, canViewCommunityMembers } = usePermissions();
  const canInvite = canInviteToCommunity({ community });
  const canViewMembers = canViewCommunityMembers({ community });

  return (
    <>
      <Card title={<Card.Title icon={<Icon icon="group-line" />}>Members</Card.Title>}>
        <Space block orientation="vertical" size="middle">
          <CommunityAdmins community={community} />
          {canViewMembers ? <CommunityMembers community={community} /> : null}
          {canInvite ? (
            <Button
              block
              icon={<Icon icon="user-add-line" />}
              onClick={() => {
                setInviteFriendsOptions({ community, isOpened: true });
              }}
              type="secondary"
            >
              Invite friends
            </Button>
          ) : null}
        </Space>
      </Card>
      <InviteFriendsModal
        onCancel={() => {
          setInviteFriendsOptions({ isOpened: false });
        }}
        options={inviteFriendsOptions}
      />
    </>
  );
};

export default CommunityMembersCard;
